import React, { useEffect, useState } from "react";
import {
  Grid,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Typography,
  Button,
  Paper,
} from "@mui/material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import validator from "validator";
import { format } from "date-fns";
import config from "../../services/config";
import "./Appointment.css";
import { useSelector } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import Swal from "sweetalert2";

const allowedDomains = ["gmail.com", "yahoo.com", "outlook.com"];
const validateEmail = (email) => {
  const [_, domain] = email.split("@");
  return validator.isEmail(email) && allowedDomains.includes(domain);
};

const Appointment = () => {
  const [formData, setFormData] = useState({
    name: "",
    age: "",
    email: "",
    phone: "",
    gender: "",
    height: "",
    weight: "",
    date: "",
    time: "", // ✅ single time slot only
    sub_category: "",
    appointment: true,
  });

  const [selectedDate, setSelectedDate] = useState(null);
  const [validationErrors, setValidationErrors] = useState({});
  const [practitionersName, setPractitionersName] = useState([]);
  const [doctorAvailableDays, setDoctorAvailableDays] = useState([]);
  const [availableTimeSlots, setAvailableTimeSlots] = useState([]);
  const [loadingg, setLoadingg] = useState(false);
  const { category, appointment, subcategory } = useSelector(
    (state) => state.GlobalVariables
  );
  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedForm = { ...formData, [name]: value };
    setFormData(updatedForm);
  };

  useEffect(() => {
    fetchAppointmentDays();
  }, []);

  const navigate = useNavigate();

  const handleDateChange = (date) => {
    setSelectedDate(date);
    const formattedDate = format(date, "yyyy-MM-dd");
    setFormData((prev) => ({ ...prev, date: formattedDate }));

    if (formData.doctor_id) {
      fetchAppointmentSlots(formData.doctor_id, formattedDate);
    }
  };

  const isDayAvailable = (date) => {
    const day = format(date, "EEEE");
    return doctorAvailableDays.includes(day);
  };

  const dayClassName = (date) => {
    const day = format(date, "EEEE");
    return doctorAvailableDays.includes(day)
      ? "available-day"
      : "unavailable-day";
  };

  const fetchAppointmentDays = async () => {
    try {
      const res = await config.getDoctorAvailableDaysOnline();
      if (res.success && Array.isArray(res.data) && res.data.length > 0) {
        const days = res.data.map((item) => item.day_of_week);

        // Set available days
        setDoctorAvailableDays(days);

        // Auto-set doctor_id from first item (if needed)
        const firstDoctorId = res.data[0].doctor_id;
        setFormData((prev) => ({
          ...prev,
          doctor_id: firstDoctorId,
        }));
      }
    } catch (err) {
      console.error(err);
    }
  };

  const fetchAppointmentSlots = async (doctorId, pickDate) => {
    try {
      const res = await config.getDoctorSlots({
        doctor_id: doctorId,
        date: pickDate,
      });
      if (res.success) {
        setAvailableTimeSlots(res.data.slots || []);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const validateForm = () => {
    const errors = {};

    if (validator.isEmpty(formData.name)) {
      errors.name = "Required";
    }

    const emailEmpty = validator.isEmpty(formData.email || "");
    const phoneEmpty = validator.isEmpty(formData.phone || "");

    if (emailEmpty && phoneEmpty) {
      errors.contact = "Either phone or email is required";
    } else {
      if (!emailEmpty && !validateEmail(formData.email)) {
        errors.email = "Invalid or unapproved email domain";
      }

      if (!phoneEmpty && !/^\d{10}$/.test(formData.phone.trim())) {
        errors.phone = "Phone must be 10 digits";
      }
    }

    if (validator.isEmpty(formData.age)) {
      errors.age = "Required";
    } else if (formData.age <= 0 || formData.age > 120) {
      errors.age = "Invalid age";
    }

    if (validator.isEmpty(formData.height)) {
      errors.height = "Required";
    } else if (formData.height < 30 || formData.height > 250) {
      errors.height = "Height must be 30-250cm";
    }

    if (validator.isEmpty(formData.weight)) {
      errors.weight = "Required";
    } else if (formData.weight < 1 || formData.weight > 500) {
      errors.weight = "Weight must be 1-500kg";
    }

    // if (!formData.doctor_id) {
    //   errors.doctor_id = "Doctor required";
    // }

    if (!formData.date) {
      errors.date = "Date required";
    }

    if (!formData.gender) {
      errors.gender = "Gender is required";
    }

    if (!formData.time) {
      errors.time = "Time slot required";
    }

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const [subCategory, setSubCategory] = useState([]);

  const [loading, setLoading] = useState(false);
  const fetchActiveSubCategory = async () => {
    try {
      setLoading(true);
      const dataToSend = {
        category: 1,
      };
      const res = await config.getActiveGroup(dataToSend);
      if (res.status === 200) {
        setSubCategory(res.data);
      } else {
        setSubCategory([]);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchActiveSubCategory();
  }, []);

  useEffect(() => {
    if (subcategory) {
      setFormData((prev) => ({
        ...prev,
        sub_category: subcategory,
      }));
    }
  }, [subcategory]);

  

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setLoadingg(true);
  
    try {
      const response = await config.guestAppointment(formData);
      if (response.success) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Appointment booked successfully!",
        });
  
        // Optionally reset form
        setFormData({
          name: "",
          age: "",
          email: "",
          phone: "",
          gender: "",
          height: "",
          weight: "",
          doctor_id: "",
          date: "",
          time: "",
          appointment: true,
          sub_category: "",
        });
        setSelectedDate(null);
        setAvailableTimeSlots([]);
        navigate("/");
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Failed to book appointment. Please try again.",
        });
      }
    } catch (error) {
      console.error("Appointment booking error:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred. Please try again later.",
      });
    } finally {
      setLoadingg(false);
    }
  };
  

  useEffect(() => {
    const fetchDoctors = async () => {
      try {
        const res = await config.getAllPractitioners();
        if (res.success) {
          setPractitionersName(res.data || []);
        }
      } catch (err) {
        console.error(err);
      }
    };
    fetchDoctors();
  }, []);
  // console.log("selectedSubCategoryId", subcategory);

  return (
    <Paper
      elevation={4}
      sx={{ p: 4, width: "100%", m: "auto", background: "white" }}
    >
      <Toaster position="top-center" />

      <Typography variant="h5" gutterBottom fontWeight={600} align="center">
        Book an Appointment
      </Typography>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          {/* Patient Fields */}
          {[
            { label: "Full Name", name: "name", type: "text" },
            { label: "Age", name: "age", type: "number" },
            { label: "Email", name: "email", type: "email" },
            { label: "Phone", name: "phone", type: "tel" },
            { label: "Height (cm)", name: "height", type: "number" },
            { label: "Weight (kg)", name: "weight", type: "number" },
          ].map(({ label, name, type }) => (
            <Grid key={name} item xs={12} sm={6} md={3}>
              <TextField
                name={name}
                label={label}
                fullWidth
                size="small"
                type={type}
                value={formData[name]}
                onChange={handleChange}
                error={
                  !!validationErrors[name] ||
                  (name === "phone" && !!validationErrors.contact)
                }
                helperText={
                  validationErrors[name] ||
                  (name === "phone" && validationErrors.contact)
                }
              />
            </Grid>
          ))}

          {/* Gender */}
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth size="small">
              <InputLabel>Gender</InputLabel>
              <Select
                name="gender"
                value={formData.gender}
                onChange={handleChange}
                error={!!validationErrors.gender}
              >
                <MenuItem value="male">Male</MenuItem>
                <MenuItem value="female">Female</MenuItem>
                <MenuItem value="other">Other</MenuItem>
              </Select>
              {validationErrors.gender && (
                <Typography color="error" fontSize={12}>
                  {validationErrors.gender}
                </Typography>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth size="small">
              <InputLabel>Pain Area</InputLabel>
              <Select
                name="sub_category"
                value={formData.sub_category || ""}
                onChange={handleChange}
                disabled={true} // Disable if Redux value exists
              >
                {subCategory.map((item) => (
                  <MenuItem
                    key={item.id}
                    value={item.id}
                    disabled={item.id === subcategory}
                  >
                    {item.group_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* Doctor */}
          {/* <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth size="small">
              <InputLabel>Doctor</InputLabel>
              <Select
                name="doctor_id"
                value={formData.doctor_id}
                onChange={handleChange}
                error={!!validationErrors.doctor_id}
              >
                {practitionersName.map((doc) => (
                  <MenuItem key={doc.id} value={doc.id}>
                    {doc.fname}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid> */}

          {/* Date */}
          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth size="small" style={{ zIndex: 10 }}>
              <DatePicker
                selected={selectedDate}
                onChange={handleDateChange}
                minDate={new Date()}
                filterDate={isDayAvailable}
                dayClassName={dayClassName}
                placeholderText="Select available date"
                className="custom-datepicker"
                dateFormat="yyyy-MM-dd"
              />
              {validationErrors.date && (
                <Typography color="error" fontSize={12}>
                  {validationErrors.date}
                </Typography>
              )}
            </FormControl>
          </Grid>

          {/* Time Slot (Single Select) */}
          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth size="small">
              <InputLabel>Time Slot</InputLabel>
              <Select
                name="time"
                value={formData.time}
                onChange={handleChange}
                error={!!validationErrors.time}
              >
                {availableTimeSlots.map((slot, index) => (
                  <MenuItem
                    key={index}
                    value={slot.time}
                    disabled={slot.status !== "available"}
                  >
                    {slot.time}{" "}
                    {slot.status === "booked"
                      ? "(Booked)"
                      : slot.status === "past"
                      ? "(Past)"
                      : ""}
                  </MenuItem>
                ))}
              </Select>
              {validationErrors.time && (
                <Typography color="error" fontSize={12}>
                  {validationErrors.time}
                </Typography>
              )}
            </FormControl>
          </Grid>

          {/* Submit Button */}
          <Grid item xs={12}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={loadingg}
            >
              {loadingg ? "saving.. .. " : "Submit Appointment"}
            </Button>
          </Grid>
        </Grid>
      </form>
    </Paper>
  );
};

export default Appointment;
